import React from 'react';
import { FilterBoxContainer } from './FilterBox.style';
import { Icon, CheckboxGroup, RadioGroup } from 'react-inv-forms';
import { CheckboxOptionType } from 'antd/lib/checkbox/Group';
import arrowUpRed from '../../../images/arrowUpRed.svg';
import useOnClickOutside from 'use-onclickoutside';

/*
  Przyjmowane właściwości
  - title - wyświetlany na górze modala i przycisku uruchamiającym
  - options - dane do wyświetlenia opcji do wyboru - zgodnie ze specyfikacją Ant Design
  - onChange - callback wykonujący się na każdej zmianie wyboru
  - selectedValues - tablica z zaznaczonymi opcjami - właściwość opcjonalna
  - opened - informacja, czy modal powinien być otwarty
  - type - typ pól wyboru
  - onClose - funkcja zamykająca modal - wykonuje się po kliknięciu na header oraz poza modalem
  - loading - informacja, czy aplikacja jest w stanie ładowania
  - noFilters - informacja o braku dostępnych filtrów
*/
interface FilterBoxProps {
  title: React.ReactElement | string;
  options: CheckboxOptionType[];
  onChange: (e: Array<string>) => void;
  selectedValues?: string[];
  opened: boolean;
  type: string;
  onClose: () => void;
  noFilters: React.ReactElement | string;
  loading: boolean;
}
/*
  W zależności od typu grupy filtrów
  - renderowane są pole wielokrotnego lub jednokrotnego wyboru
*/
const renderOptions = (props: FilterBoxProps): React.ReactElement | string => {
  const onChange = (type: string, data: any): void => {
    switch (type) {
      case 'checkbox':
        props.onChange(data);
        break;
      case 'radio':
        props.onChange([data.target.value]);
        props.onClose();
        break;
    }
  };
  switch (props.type) {
    case 'checkbox':
      return (
        <CheckboxGroup
          value={props.selectedValues ? props.selectedValues : []}
          options={props.options}
          onChange={onChange.bind(null, 'checkbox')}
          disabled={props.loading}
        />
      );
    case 'radio':
      return (
        <RadioGroup
          defaultValue={props.selectedValues ? props.selectedValues[0] : null}
          options={props.options}
          onChange={onChange.bind(null, 'radio')}
          disabled={props.loading}
        />
      );
    default:
      return props.noFilters;
  }
};

/* Komponent modala wyświetlającego pola wyboru */
export const FilterBox: React.FunctionComponent<FilterBoxProps> = (props: FilterBoxProps) => {
  const ref = React.useRef<HTMLDivElement>(null);
  useOnClickOutside(ref, (event: any) => {
    const node = ref.current;
    if (node && !node.contains(event.target)) {
      props.onClose();
    }
  });
  return (
    <FilterBoxContainer ref={ref} opened={props.opened} data-cy='filterModal'>
      <h4 onClick={props.onClose}>
        {props.title} <Icon path={arrowUpRed} />
      </h4>
      {!props.loading && !props.options.length ? props.noFilters : renderOptions(props)}
    </FilterBoxContainer>
  );
};
